module.exports = __webpack_public_path__ + "static/media/PATS_7-1267w.5eaa0512.png";